const MONTHS = [
	'янв',
	'фев',
	'мар',
	'апр',
	'мая',
	'июн',
	'июл',
	'авг',
	'сен',
	'окт',
	'ноя',
	'дек',
]
const MAX_PERCENT = 100

// Parses the string instead of building a Date, so the label never shifts with the time zone
export const formatDayLabel = isoDate => {
	const [, month, day] = isoDate.split('-')
	return `${Number(day)} ${MONTHS[Number(month) - 1]}`
}

export const toBars = days => {
	const max = Math.max(0, ...days.map(({ requests }) => requests))

	return days.map(({ date, requests }) => ({
		date,
		label: formatDayLabel(date),
		requests,
		heightPercent: max > 0 ? Math.round((requests / max) * MAX_PERCENT) : 0,
	}))
}
